import React from "react";
import "./App.css";
// import Header from "./components/ui/Header";
import Home from "./components/pages/Home";

function App() {
  return (
    <div className="App bg-black h-[100vh]">
      {/* <Header /> */}
      <Home />
    </div>
  );
}

export default App;
